import axios from './index'
const origin = '/co/home/'

//获取今日行程列表
const LoadTodayListItineraries = (param) => {
    return new Promise(resolve => {
        axios.post(origin + 'LoadTodayListItineraries',param).then(res => resolve(res))
    })
}
//获取今日行程中各线路对应的数据个数
const GetTodayListItinerariesCount = () => {
    return new Promise(resolve => {
        axios.post(origin + 'GetTodayListItinerariesCount').then(res => resolve(res))
    })
}
//获取昨日上报行程、昨日接待人数、累计上报行程、累计接待人数
const LoadDatas = () => {
    return new Promise(resolve => {
        axios.post(origin + 'LoadDatas').then(res => resolve(res))
    })
}
//获取新增订单列表
const LoadListOrder = (param) => {
    return new Promise(resolve => {
        axios.post(origin + 'LoadListOrder',param).then(res => resolve(res))
    })
}
//获取新增订单中各线路对应的数据个数
const GetListOrderCount = () => {
    return new Promise(resolve => {
        axios.post(origin + 'GetListOrderCount').then(res => resolve(res))
    })
}



export default {
    LoadTodayListItineraries,
    GetTodayListItinerariesCount,
    LoadDatas,
    LoadListOrder,
    GetListOrderCount,
}